import { useContext } from 'react'

import cn from 'classnames'
import settings from '../../settings'

import { useLanguageMenu } from 'mmfintech-checkout-commons'

import { ThemeContext } from 'styled-components'
import { ChevronDownIcon, ChevronUpIcon } from '@icons'
import { MenuContainer, MenuDropDown, MenuWrapper } from './LanguageMenu.styled'

const LanguageMenu = () => {
  const themeContext = useContext(ThemeContext)

  const {
    dropdownOpened,
    selectedLanguage,
    languages,
    getLanguageName,
    handleDropDownClick,
    handleLanguageChange,
    setRef
  } = useLanguageMenu(settings.languages)

  return selectedLanguage ? (
    <MenuWrapper data-test='language-menu-wrapper' ref={setRef}>
      <MenuContainer className={cn({ opened: dropdownOpened })} onClick={handleDropDownClick}>
        <span className='selected'>{getLanguageName(selectedLanguage)}</span>
        <span className='arrow'>
          {dropdownOpened ? (
            <ChevronUpIcon color={themeContext.languageMenu.color} />
          ) : (
            <ChevronDownIcon color={themeContext.languageMenu.color} />
          )}
        </span>
      </MenuContainer>
      <MenuDropDown className={cn({ opened: dropdownOpened })} data-test='language-menu-content'>
        <ul data-test='language-menu-list'>
          {languages.map(language => (
            <li key={language.code} onClick={() => handleLanguageChange(language.code)} data-test='language-menu-item'>
              {language.name}
            </li>
          ))}
        </ul>
      </MenuDropDown>
    </MenuWrapper>
  ) : null
}

export default LanguageMenu
